module.exports = __webpack_public_path__ + "static/media/ic-supermarket.b04185e8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/ic-supermarket.svg
// module id = 444
// module chunks = 0